export const trimEllipse = (text = '', maxLength) => {
  if (!maxLength || text.length <= maxLength) {
    return text;
  }

  return `${text.substring(0, maxLength)}...`;
};
